import firebaseService from "app/services/firebaseService";
import jwtService from "app/services/jwtService";
import { setUserData } from "./user.actions";
import * as Actions from "app/store/actions";

export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export function submitLogin({ email, password }) {
	return (dispatch) =>
		jwtService
			.signInWithEmailAndPassword(email, password)
			.then((user) => {
				dispatch(setUserData(user));

				return dispatch({
					type: LOGIN_SUCCESS,
				});
			})
			.catch((error) => {
				return dispatch({
					type: LOGIN_ERROR,
					payload: error,
				});
			});
}

export function submitLoginWithFireBase({ email, password }) {
	return (dispatch) =>
		firebaseService.auth &&
		firebaseService.auth
			.signInWithEmailAndPassword(email, password)
			.then(() => {
				return dispatch({
					type: LOGIN_SUCCESS,
				});
			})
			.catch((error) => {
				console.log("error: ", error);
				const usernameErrorCodes = [
					"auth/email-already-in-use",
					"auth/invalid-email",
					"auth/operation-not-allowed",
					"auth/user-not-found",
					"auth/user-disabled",
				];
				const passwordErrorCodes = [
					"auth/weak-password",
					"auth/wrong-password",
				];

				if (error.code === "auth/operation-not-allowed")
					error.message = "허용되지 않는 요청입니다.";
				if (error.code === "auth/user-not-found")
					error.message = "없는 계정입니다.";
				if (error.code === "auth/user-disabled")
					error.message = "사용할 수 없는 계정입니다.";
				if (error.code === "auth/email-already-in-use")
					error.message = "이미 등록된 이메일입니다.";
				if (error.code === "auth/weak-password")
					error.message = "너무 쉬운 비밀번호입니다.";
				if (error.code === "auth/wrong-password")
					error.message = "잘못된 비밀번호입니다.";

				const response = {
					email: usernameErrorCodes.includes(error.code) ? error.message : null,
					password: passwordErrorCodes.includes(error.code)
						? error.message
						: null,
				};

				if (error.code === "auth/invalid-api-key") {
					dispatch(Actions.showMessage({ message: error.message }));
				}
				dispatch(Actions.showMessage({ message: error.message }));

				return dispatch({
					type: LOGIN_ERROR,
					payload: response,
				});
			});
}
